function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M1 20C1 9.484 9.518.955 20.02.955 30.544.955 39.037 9.485 39.037 20c0 10.54-8.493 19.045-19.02 19.045C9.52 39.045 1 30.54 1 20z",
  fill: "#fff",
  fillRule: "evenodd"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M.52 20.017C.52 9.255 9.25.527 20.013.527c10.788 0 19.492 8.728 19.492 19.49 0 10.79-8.704 19.492-19.492 19.492C9.25 39.51.522 30.805.522 20.016",
  className: "icon-tertiary",
  fill: "none",
  stroke: "#002060",
  strokeWidth: 0.79999989,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref4 =
/*#__PURE__*/
React.createElement("g", {
  className: "icon-secondary",
  fill: "#adb9ca",
  fillRule: "evenodd"
}, React.createElement("path", {
  d: "M17.795 7.16c.905 0 1.738.337 2.325.84l.514.65h3.893V7.308l5.605 2.705-5.605 2.727v-1.364h-3.893l-.514.672c-.587.503-1.42.817-2.325.817-1.836 0-3.33-1.258-3.33-2.852 0-1.573 1.494-2.852 3.33-2.852zM18.007 15.135c.91 0 1.745.334 2.36.835l.516.648h7.62V15.28l5.63 2.695-5.63 2.714V19.33h-7.62l-.516.668c-.615.5-1.45.814-2.36.814-1.844 0-3.343-1.252-3.343-2.84 0-1.565 1.5-2.84 3.343-2.84z"
}));

var _ref5 =
/*#__PURE__*/
React.createElement("g", {
  className: "icon-tertiary",
  fill: "none",
  stroke: "#002060",
  strokeWidth: 0.80000001,
  strokeLinecap: "round",
  strokeLinejoin: "bevel"
}, React.createElement("path", {
  d: "M17 6.88c1.01 0 1.937.37 2.59.926l.574.718H24.5V7.042l6.248 2.987-6.247 3.01v-1.506h-4.336l-.573.742c-.653.555-1.58.903-2.59.903-2.046 0-3.71-1.39-3.71-3.15 0-1.738 1.664-3.15 3.71-3.15zM16.934 14.9c1.002 0 1.923.37 2.6.927l.57.72h8.398V15.06l6.204 2.99-6.204 3.013V19.56h-8.398l-.57.74c-.677.557-1.134.3-2.137.3-2.032 0-2.823-1.058-2.823-2.82 0-1.738.328-2.88 2.36-2.88z"
}));

var _ref6 =
/*#__PURE__*/
React.createElement("g", {
  className: "icon-primary",
  fill: "#ecaec6",
  fillRule: "evenodd"
}, React.createElement("path", {
  d: "M16.492 23.406c-2.69 0-4.875-2.17-4.875-4.875V9.595c0-2.692 2.184-4.875 4.875-4.875 2.704 0 4.875 2.182 4.875 4.874v8.937c0 2.705-2.17 4.876-4.875 4.876zM11.82 30.45c0-2.633 2.102-4.774 4.67-4.774 2.582 0 4.67 2.14 4.67 4.774 0 2.646-2.088 4.774-4.67 4.774-2.568 0-4.67-2.128-4.67-4.774z"
}));

var _ref7 =
/*#__PURE__*/
React.createElement("g", {
  className: "icon-tertiary",
  fill: "none",
  stroke: "#002060",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, React.createElement("path", {
  d: "M16.492 23.57c-2.746 0-4.974-2.212-4.974-4.968v-9.11c0-2.745 2.228-4.97 4.974-4.97 2.76 0 4.974 2.225 4.974 4.97v9.11c0 2.756-2.215 4.97-4.974 4.97z",
  strokeWidth: 0.79999983
}), React.createElement("path", {
  d: "M11.49 30.49c0-2.774 2.258-5.03 5.02-5.03 2.774 0 5.02 2.256 5.02 5.03 0 2.79-2.246 5.032-5.02 5.032-2.762 0-5.02-2.242-5.02-5.03",
  strokeWidth: 0.80000013
}));

var SvgInsightSubmenuDo = function SvgInsightSubmenuDo(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 40,
    height: 40,
    ref: svgRef
  }, props), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgInsightSubmenuDo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Insight-submenu-do.28fca368.svg";
export { ForwardRef as ReactComponent };